import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { cmsReducers, cmsSelectors } from '@zillow/zhl-redux-commons';
import LoanTypeComparison from './LoanTypeComparison';

export default connect(
    state => ({
        cms: cmsSelectors.cmsLatestDocumentsContentsSelector(state),
    }),
    dispatch =>
        bindActionCreators(
            {
                fetchMarkdownDocument: cmsReducers.fetchMarkdownDocument,
            },
            dispatch
        )
)(LoanTypeComparison);
